import React from 'react';
import { SupplierFormModal } from '@/pages/suppliers/components/supplierFormModal';
import { useCreateSupplier } from '@/pages/suppliers/useCreateSupplier';
import { PATH } from '@/router/PATH';
import type { ActionSurfaceProps } from '../../controlCenterSurfaces';

/** "Add supplier" from the launcher. See `AddBrandSurface` for the shape. */
export const AddSupplierSurface: React.FC<ActionSurfaceProps> = ({
    onClose,
    onDone,
}) => {
    const [error, setError] = React.useState<string | null>(null);
    const { create, isCreating } = useCreateSupplier();

    return (
        <SupplierFormModal
            error={error}
            initialValues={null}
            isOpen
            isSubmitting={isCreating}
            mode="create"
            onClose={onClose}
            onSubmit={async (input) => {
                setError(null);
                const created = await create(input);
                if (!created.ok) {
                    setError(created.message);
                    return;
                }
                onDone({
                    messageKey: 'controlCenter.outcome.supplierAdded',
                    messageParams: { name: input.name },
                    to: PATH.SUPPLIERS,
                    linkKey: 'controlCenter.outcome.openSuppliers',
                });
            }}
        />
    );
};
